import { SignalHookScopeType } from "../types";
import { getScopeTypeLabel } from "../utils";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SCOPE_TYPES = Object.values(SignalHookScopeType);

interface ScopeTypeSelectProps {
  value: SignalHookScopeType;
  onChange: (value: SignalHookScopeType) => void;
  disableAllRequests?: boolean;
}

const ScopeTypeSelect = ({ value, onChange, disableAllRequests = false }: ScopeTypeSelectProps) => (
  <div className="space-y-2">
    <p className="text-sm font-medium text-gray-700">Run this signal on</p>
    <Select value={value} onValueChange={nextValue => onChange(nextValue as SignalHookScopeType)}>
      <SelectTrigger className="w-full bg-white">
        <SelectValue placeholder="Select scope" />
      </SelectTrigger>
      <SelectContent>
        {SCOPE_TYPES.map(scopeType => (
          <SelectItem
            key={scopeType}
            value={scopeType}
            disabled={scopeType === SignalHookScopeType.ALL_REQUESTS && disableAllRequests}
          >
            {getScopeTypeLabel(scopeType)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default ScopeTypeSelect;
